

import { LoadingProps } from "../typings/ViewTypes";
import {Updater,SplitLayout} from "@npd-ng/adp-component-library";
import { IADPState } from "../typings";
import {useSelector } from "react-redux";
export const DeviceValidationWaitingView = () => {
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  );
  const loadingProps: LoadingProps = {
    title: state.currentLanguageContent?.deviceValidationWait.title || "",
    message: state.currentLanguageContent?.deviceValidationWait.message || "",
    subTitle:state.currentLanguageContent?.deviceValidationWait.subTitle || "",
    spinnerAlt:state.currentLanguageContent?.imageAltText.verifyingIcon as string
};
  return (
    <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string}>
      <Updater {...loadingProps} type="wait" />
    </SplitLayout>
  )
}


